import { toLocalEndOfDay, toLocalStartOfDay } from "@/matteroomTab/Utils";
import { getStoredLoginUserId } from "@/utils/currentUser";

export const buildDailyTimeEntriesQuery = (
  dateKey: string,
  userId?: string | number,
) => {
  const loginUserId = getStoredLoginUserId();
  const isDelegatedUser =
    userId && loginUserId && String(userId) !== String(loginUserId);

  return isDelegatedUser
    ? `?delegators=${userId}&start_date=${toLocalStartOfDay(dateKey)}&end_date=${toLocalEndOfDay(dateKey)}`
    : `?start_date=${toLocalStartOfDay(dateKey)}&end_date=${toLocalEndOfDay(dateKey)}`;
};
